import { render } from "./soal-2_pg_dengan_narasi.vue?vue&type=template&id=69739cf0&scoped=true"
import script from "./soal-2_pg_dengan_narasi.vue?vue&type=script&lang=js"
export * from "./soal-2_pg_dengan_narasi.vue?vue&type=script&lang=js"

import "./soal-2_pg_dengan_narasi.vue?vue&type=style&index=0&id=69739cf0&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69739cf0"]])

export default __exports__